(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5e9f28b"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__aiHeroTInit) return;
    window.__aiHeroTInit = true;

    function initHeroVideos() {
      var videos = document.querySelectorAll('.ai-hero-t__media video:not([data-hero-init])');
      if (!videos.length) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var observer = 'IntersectionObserver' in window
        ? new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting) {
                if (!reduceMotion) v.play().catch(function () {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          }, { threshold: 0.1 })
        : null;

      videos.forEach(function (v) {
        v.setAttribute('data-hero-init', '');
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        v.setAttribute('disableremoteplayback', '');

        if (observer) {
          observer.observe(v);
        } else if (!reduceMotion) {
          v.play().catch(function () {});
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHeroVideos);
    } else {
      initHeroVideos();
    }

    document.addEventListener('shopify:section:load', initHeroVideos);
    document.addEventListener('shopify:block:select', initHeroVideos);
  })();
  } catch(e) { console.error(e); }
})();

})();
